
// ///storage constant
export default {
    STORAGE_URL: "https://storage.oms.innovate10x.com",
    OLD_STORAGE_URL:
        "http://storage.oms.com.s3-website-us-east-1.amazonaws.com",
    SERVERS_URL: "https://oms-servers.oms.innovate10x.com/OMS-SERVERS-LIST"
}
